import {useEffect, useState} from "react";
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import { formatNumbers } from "../../../../../../util/state/commonFunctions";

type Props = {
    result: any
}
const BarChartReport = ({result}: Props) => {
    // REPORT 1
    const [barChartValues, setBarChartValues] = useState<{ [key: string]: string | number }[]>([]);

    function getRandomColor() {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    useEffect(() => {
        setBarChartValues(result?.map((el: any) => {
            const dataElement: any = {};
            dataElement.name = el.name;
            el.values.forEach((month: any) => dataElement[month.name] = formatNumbers(month.value / 100));
            return dataElement;
        }));
    }, [result]);

    return (
        <ResponsiveContainer width="95%" height={500}>
            <BarChart
                width={100}
                height={500}
                data={barChartValues}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5
                }}
            >
                <CartesianGrid strokeDasharray="3 3"/>
                <XAxis dataKey="name"/>
                <YAxis/>
                <Tooltip/>
                <Legend/>
                {
                    barChartValues?.length > 0 && Object.keys(barChartValues[0]).map((key) => (
                        key !== "name" && <Bar key={key} dataKey={key} fill={getRandomColor()}/>
                    ))
                }

            </BarChart>
        </ResponsiveContainer>
    );
};

export default BarChartReport;